import { render } from "./VersionDisplay.vue?vue&type=template&id=02a3af05&scoped=true"
import script from "./VersionDisplay.vue?vue&type=script&lang=js"
export * from "./VersionDisplay.vue?vue&type=script&lang=js"

import "./VersionDisplay.vue?vue&type=style&index=0&id=02a3af05&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a3af05"]])

export default __exports__